import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ScholarshipTypeType } from "../../../types/ScholarshipType";
const initialState: ScholarshipTypeType = {
    description: "",
    status: true,
    id: "",
};
export const scholarshipTypeSlice = createSlice({
    name: "scholarshipTypeForm",
    initialState,
    reducers: {
        setScholarshipTypeData: (state, action: PayloadAction<ScholarshipTypeType>) => {
            return { ...state, ...action.payload };
        },
        resetScholarshipTypeData: () => {
            return initialState;
        }
    }
});
export const { setScholarshipTypeData, resetScholarshipTypeData } = scholarshipTypeSlice.actions;
export default scholarshipTypeSlice.reducer;
